import React from 'react';
import Icon from './Icon';
import NotificationBell from './NotificationBell';
import '../styles/TopNav.css';

const TopNav = ({ user, activeSection = 'dashboard', onToggleMobileNav }) => {
  // Determine user role for breadcrumbing
  const isSuperAdmin = user?.is_super_admin || false;
  const isAdmin = user?.is_admin || false;

  const sectionMap = {
    'dashboard': { label: 'Dashboard', icon: 'home' },
    'todo': { label: 'To Do List', icon: 'check' },
    'create': { label: 'Content', sublabel: 'Create Content', icon: 'content' },
    'review': { label: 'Review', icon: 'check' },
    'calendar': { label: 'Meetings', icon: 'calendar' },
    'library': { label: 'Brand Hub', sublabel: 'Library', icon: 'vkontakte-rect' },
    'analytics': { label: 'Analytics', icon: 'chart-bar' },
    'notifications': { label: 'Notifications', icon: 'bell' },
    'menu-item-1': { label: 'Menu Item 1', icon: 'server' },
    'menu-item-2': { label: 'Menu Item 2', icon: 'go-to-link' },
    'user-management': { label: 'User Management', icon: 'user' },
    'admin-invitations': { label: 'Invitations', icon: 'paper-plane-empty' },
    'admin-organizations-brands': { label: 'Organization', icon: 'building' },
    'gemini': { label: 'Velvet AI', icon: 'ai' },
    'profile': { label: 'Profile', icon: 'user' },
    'operator-review-ideas': { label: 'Ideas', sublabel: 'Review Ideas', icon: 'lightbulb' },
    'client-review-ideas': { label: 'Ideas', sublabel: 'Review Ideas', icon: 'lightbulb' },
    'create-ideas': { label: 'Ideas', sublabel: 'Create Ideas', icon: 'lightbulb' },
    'assets': { label: 'Brand Hub', sublabel: 'Identity', icon: 'vkontakte-rect' },
    'brand-builder': { label: 'Brand Hub', sublabel: 'Brand Voice Designer', icon: 'vkontakte-rect' },
    'sources': { label: 'Sources', sublabel: 'Manage Sources', icon: 'sources' },
    'recordings': { label: 'Sources', sublabel: 'Squadcast', icon: 'sources' },
    'velvet-recordings': { label: 'Sources', sublabel: 'Velvet Recordings', icon: 'sources' },
    'livekit-meetings': { label: 'Velvet Meetings', icon: 'velvet' },
    'review-content': { label: 'Content', sublabel: 'Review Content', icon: 'content' },
    'schedule-posts': { label: 'Schedule', icon: 'calendar-check-o' },
    'accessible-clients': { label: 'Accessible Clients', icon: 'user' },
    'assigned-clients': { label: 'Assigned Clients', icon: 'user' },
    'assigned-organizations': { label: 'Assigned Organizations', icon: 'building' },
    'assigned-brands': { label: 'Assigned Brands', icon: 'tag' },
    'assignments': { label: 'Assignments', icon: 'tasks' },
    'reports': { label: 'Reports', icon: 'chart-bar' },
    'organizations': { label: 'Organizations', icon: 'building' },
    'brands': { label: 'Brands', icon: 'tag' },
    // Super Admin sections - show "Super Admin / Panel Name"
    'admin-user-management': isSuperAdmin
      ? { label: 'Super Admin', sublabel: 'User Management', icon: 'superadmin' }
      : { label: 'Admin', sublabel: 'User Management', icon: 'admin' },
    'prompt-hub': { label: 'Super Admin', sublabel: 'Prompt Hub', icon: 'superadmin' },
    'agency-hub': { label: 'Agency Hub', icon: 'server' },
    'proxy-user': isSuperAdmin
      ? { label: 'Super Admin', sublabel: 'Proxy User', icon: 'superadmin' }
      : { label: 'Admin', sublabel: 'Proxy User', icon: 'admin' },
    'casper': { label: 'Super Admin', sublabel: 'Casper', icon: 'superadmin' },
    'guest-completions': { label: 'Super Admin', sublabel: 'Guest Completions', icon: 'superadmin' },
    'activity-log': isSuperAdmin
      ? { label: 'Super Admin', sublabel: 'Activity Logs', icon: 'superadmin' }
      : { label: 'Admin', sublabel: 'Activity Logs', icon: 'admin' },
    'logs': { label: 'Super Admin', sublabel: 'System Logs', icon: 'superadmin' },
  };

  const currentSection = sectionMap[activeSection] || sectionMap['dashboard'];

  return (
    <nav className="top-nav">
      <div className="top-nav-left">
        {onToggleMobileNav && (
          <button
            className="mobile-nav-toggle"
            onClick={onToggleMobileNav}
            title="Open menu"
            aria-label="Open menu"
          >
            <Icon name="menu" size="1.5rem" />
          </button>
        )}
        <div className="current-section">
          <Icon name={currentSection.icon} size="1.5rem" />
          <span className="section-label">{currentSection.label}</span>
          {currentSection.sublabel && (
            <>
              <span className="section-divider">/</span>
              <span className="section-label">{currentSection.sublabel}</span>
            </>
          )}
        </div>
      </div>

      <div className="top-nav-right">
        <NotificationBell user={user} />
      </div>
    </nav>
  );
};

export default TopNav;
